import {initParamChooser} from './initParamChooser';
import {initVisualChooser} from './initVisualChooser';

export const initChooser = () => {
	const choosers = document.querySelectorAll( 'section.chooser, section.first-screen' );

	if ( !choosers.length )
	{
		return;
	}

	Array.from( choosers ).forEach( ( chooser ) => {
		const isParam = chooser.classList.contains( 'param' ) || chooser.classList.contains( 'first-screen' );

		if ( isParam )
		{
			initParamChooser( chooser )
		}
		else
		{
			initVisualChooser( chooser );
		}
	} );
};
